export const createQuestionsService = (http, baseUrl) => {
  const buildURL = (path, params = {}) => {
    const query = new URLSearchParams(params).toString()
    if (query) {
      return `${baseUrl}${path}?${query}`
    }
    return `${baseUrl}${path}`
  }

  const actions = {
    getQuestionList ({ page = 1, limit = 10, groupId = '', search = '', sort = '', order = '' } = {}) {
      const params = { page, limit }
      if (groupId) params.group_id = groupId
      if (search) params.search = search
      if (sort) params.sort = sort
      if (order) params.order = order

      const url = buildURL('/user/question/list', params)

      return http.get(url)
    },

    exportQuestions (groupId = '') {
      const params = {}
      if (groupId) params.group_id = groupId

      const url = buildURL('/user/question/export', params)

      return http.getBlob(url)
    },

    importQuestions (items) {
      const url = buildURL('/user/question/import')

      // Bulk inserts run one INSERT per row over the D1 bridge, so allow much
      // longer than the default request timeout for large imports.
      return http.post(url, { items }, { timeout: 120000 })
    },

    getQuestion (groupId = null, options = null) {
      const qParams = {}

      if (groupId) qParams.group_id = groupId
      if (options) qParams.options = options

      const url = buildURL('/user/question', qParams)

      return http.get(url)
    },

    postAnswer (data) {
      const url = buildURL('/user/question/answer')

      return http.post(url, data)
    },

    // New CRUD methods
    getQuestionById (id) {
      const url = buildURL(`/user/question/${id}`)
      return http.get(url)
    },

    createQuestion (questionData) {
      const url = buildURL('/user/question')
      return http.post(url, questionData)
    },

    updateQuestion (id, questionData) {
      const url = buildURL(`/user/question/${id}`)
      return http.put(url, questionData)
    },

    deleteQuestion (id) {
      const url = buildURL(`/user/question/${id}`)
      return http.delete(url)
    }
  }

  return actions
}
